import React from 'react';
import PropTypes from 'prop-types';

/**
 * カスタムツールチップ
 * リンク形式（機種名など）のツールチップを表示する
 */
class CustomTooltipModelNameElement extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTooltip: false,
      tooltipX: 0,
      tooltipY: 0,
      tooltipText: '',
      isVisibility: 'hidden',
      isCopyNoticeVisibility: false,
    };
    this.tooltipNode = null;
    this.showTimer = null;

    this.setTooltipRef = this.setTooltipRef.bind(this);
    this.handleLinkClick = this.handleLinkClick.bind(this);
    this.handleLinkMouseEnter = this.handleLinkMouseEnter.bind(this);
    this.handleLinkMouseLeave = this.handleLinkMouseLeave.bind(this);
    this.handleTooltipMouseLeave = this.handleTooltipMouseLeave.bind(this);
    this.handleCopy = this.handleCopy.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.showTimer);
  }

  setTooltipRef(el) {
    this.tooltipNode = el;
  }

  handleLinkClick(e) {
    if (this.props.targetLink == undefined || this.props.targetLink == '') {
      // リンクが存在しない場合は何もしない
      e.preventDefault();
    }
  }

  handleLinkMouseEnter(e) {
    const text = e.target.textContent;
    const rect = e.target.getBoundingClientRect();
    const widthLimit = document.getElementById('main').clientWidth;

    // ツールチップが見切れないように調整
    let posX = rect.left + (window.scrollX || document.documentElement.scrollLeft);

    let posY;
    if (location.pathname.indexOf('K015') != -1) {
      // hoverされたaタグから見た2階層上の親要素を取得する
      const parentNode = e.target.parentNode.parentNode;
      // 親要素のID
      const parentNodeId = parentNode.id;
      // スクロールの親要素を取得
      const parentDiv = document.getElementById('main');
      const targetTd = document.getElementById(parentNodeId);

      let offsetTop = 0;
      let current = targetTd;

      // 親要素までのoffset値を加算する
      while (current && current !== parentDiv && current !== document.body) {
        offsetTop += current.offsetTop;
        current = current.offsetParent;
      }

      posY = offsetTop + (parentNode.offsetHeight / 2 + e.target.offsetHeight / 2) - 4;

      if (parentDiv.scrollHeight < (posY + 100)) {
        // 画面から見切れる位置での表示の場合はコンテンツの上側に表示するよう調整
        posY -= 100;
      }
    } else {
      posY = rect.top + (window.scrollY || document.documentElement.scrollTop) - 92;
      if ($('#footer').position().top < (posY + 180)) {
        // 画面から見切れる位置での表示の場合はコンテンツの上側に表示するよう調整
        posY -= 100;
      }
    }

    // 遅延してツールチップを表示
    this.showTimer = setTimeout(() => {
      this.setState({
        showTooltip: true,
        tooltipText: text,
        tooltipX: posX,
        tooltipY: posY,
      });

      // 画面右端が見切れないように位置調整
      const element = document.getElementById('tooltip_content_parent');
      const overWidth = (posX + element.getBoundingClientRect().width) - widthLimit;
      if (overWidth > 0) {
        posX -= overWidth + 4;
      }

      this.setState({ isVisibility: '', tooltipX: posX });
    }, 400);
  }

  handleLinkMouseLeave(e) {
    if (this.isHoveringTooltip(e.relatedTarget)) return;
    // マウス離れたら遅延中でもキャンセルして非表示
    clearTimeout(this.showTimer);
    this.setState({ showTooltip: false });
    const noticeElement = document.getElementById('tooltip_copy_notice');
    if (noticeElement != null) {
      noticeElement.style.display = 'none';
    }
  }

  handleTooltipMouseLeave(e) {
    if (this.isHoveringTooltip(e.relatedTarget)) return;
    this.setState({ showTooltip: false });
    const noticeElement = document.getElementById('tooltip_copy_notice');
    if (noticeElement != null) {
      noticeElement.style.display = 'none';
    }
  }

  isHoveringTooltip(to) {
    return (this.tooltipNode && to instanceof Node && this.tooltipNode.contains(to));
  }

  handleCopy() {
    let posX = 0;
    // ツールチップ情報を取得
    const tooltipContentRect = document.getElementById('tooltip_content_parent').getBoundingClientRect();
    // 画面の描画領域を取得
    const widthLimit = document.getElementById('main').clientWidth;
    // ツールチップアイコンの位置を取得
    const tooltipIconRect = document.getElementById('tooltip_copy_icon').getBoundingClientRect();
    // 描画できる残りを取得(画面描画領域 - ツールチップのコピーアイコン位置 - コピー通知吹き出しの横幅)
    const gapWidth = (widthLimit - tooltipIconRect.left) - 200;
    if (gapWidth < 0) {
      // 見切れる画面右端に併せる
      posX = tooltipContentRect.width - 200;
    } else {
      // ツールチップのコピーアイコンの上に表示する(ツールチップの横幅 - 吹き出しとんがり部分 - border変形値 - アイコンのpadding)
      posX = tooltipContentRect.width - 24 - 15 - 15;
    }

    navigator.clipboard.writeText(this.state.tooltipText).then(() => {
      this.setState({ copySuccess: true });

      // コピー完了の領域を表示する
      const noticeElement = document.getElementById('tooltip_copy_notice');
      noticeElement.style.display = 'block';

      // 上に引き上げる(吹き出しの高さ+吹き出しとんがり)
      noticeElement.style.top = '-67px';
      noticeElement.style.left = posX + 'px';

      setTimeout(() => {
        noticeElement.style.display = 'none';
      }, 3000);
      setTimeout(() => this.setState({ copySuccess: false }), 1500);
    }, () => {});
  }

  render() {
    const targetLink = this.props.targetLink;
    const modelName =  this.props.modelName;
    const brandName =  this.props.brandName;

    let toolTip = null;

    if (this.state.showTooltip) {
      const stylePos = {
        top: this.state.tooltipY,
        left: this.state.tooltipX,
        visibility: this.state.isVisibility
      };

      toolTip = (
        <div id="tooltip_content_parent" className="tooltip_content_parent" ref={this.setTooltipRef} style={stylePos} onMouseLeave={this.handleTooltipMouseLeave}>
          <div className="tooltip_content_inner">
            <span className="tooltip_content_model_name">{modelName}</span>
            <span id="tooltip_copy_icon" className="tooltip_copy_icon" onClick={this.handleCopy} />
          </div>
          <span className="tooltip_content_brand_name">{brandName}</span>
          <div id="tooltip_copy_notice" className="tooltip_copy_notice_area">
            <div className="tooltip_copy_notice_area_content">
              <span className="tooltip_copy_notice_icon" />
              <span className="tooltip_copy_notice_text" >機種名がコピーされました</span>
            </div>
            <div className="modal_arrow_tooltip_border" />
            <div className="modal_arrow_tooltip" />
          </div>
        </div>
      );
    }

    return (
      <div className="custom_tooltip_parent">
        <a onClick={e => this.handleLinkClick(e)} href={targetLink} className="model_name" onMouseEnter={this.handleLinkMouseEnter} onMouseLeave={this.handleLinkMouseLeave}>{modelName}</a>
        {toolTip}
      </div>
    );
  }
}

CustomTooltipModelNameElement.propTypes = {
  targetLink: PropTypes.any.isRequired,
  modelName: PropTypes.any.isRequired,
  brandName: PropTypes.any.isRequired,
};

export default CustomTooltipModelNameElement;
